import styled from 'styled-components'

function getProgressStyle(nextActive) {
  return nextActive
    ? `font-size: 16px;
  font-weight: 700;
  line-height: 24px;`
    : `font-size: 10px;
  font-weight: 400;
  line-height: 16px;`
}

export const Wrapper = styled.div`
  margin-top: 40px;
  padding: 16px;
  position: relative;
  background-color: #eefaff;
`

export const Heading = styled.h2`
  position: absolute;
  top: -10%;
  left: 50%;
  transform: translateX(-50%);
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 800;
  line-height: 24px;
  color: #005085;
  background-color: white;
  padding: 8px 16px;
  border-radius: 24px;
  box-shadow: 0px 2px 10px 0px #6393b34d;
  min-width: max-content;
`

export const BonusWrapper = styled.div`
  padding-top: 16px;
  min-height: 260px;
`

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const Line = styled.div`
  display: flex;
  flex-grow: 1;
  border-top: 1px solid #d0e2ea;
`

export const CurrentDate = styled.h2`
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
  color: #6393b3;
`

export const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-top: 48px;
  position: relative;
`
export const Steps = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  &:last-child {
    margin-right: 8px;
  }
`
export const EachStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export const StepWrapper = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.isPublished ? 'white' : '#5A5A5A')};
  background-color: ${(props) => (props.isPublished ? '#1DB555' : 'white')};
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`

export const DailyChapterText = styled.p`
  font-family: Noto Sans;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  color: black;
  position: absolute;
  bottom: -26%;
`
export const ChapterText = styled.p`
  font-family: Noto Sans;
  font-size: 8px;
  font-weight: 500;
  line-height: 12px;
  color: black;
`
export const LineProgress = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;

  :before {
    content: '';
    position: absolute;
    background: #d2e3ea;
    height: 12px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    border-radius: 8px;
  }
  :after {
    content: '';
    position: absolute;
    background: #0ed056;
    height: 12px;
    width: ${(props) => props.stepperWidth};
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: ${(props) => props.allStepsCompleted && '8px'};
    border-bottom-right-radius: ${(props) => props.allStepsCompleted && '8px'};
  }
`

export const StepLine = styled.div`
  position: relative;
  margin-left: 4px;
  height: ${(props) => (props.nextActive ? '60px' : '24px')};
  border: ${(props) =>
    props.isActive ? '1px solid #0ED056' : '1px solid #C8E2EC'};
`

export const GradientLine = styled.div`
  position: absolute;
  right: 1px;
  top: -5%;
  width: 80px;
  height: ${(props) => (props.nextActive ? '60px' : '24px')};
  background: ${(props) =>
    !props.isActive
      ? 'transparent'
      : `linear-gradient(
    270deg,
    #0ed056 0%,
    rgba(14, 208, 86, 0.2) 50.52%,
    rgba(14, 208, 86, 0) 100%
  )`};
`

export const Circle = styled.div`
  position: absolute;
  bottom: -3px;
  left: -2px;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${(props) => (props.isActive ? '#0ED056' : '#C8E2EC')};
`

export const EachProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6px;
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  width: ${(props) => (props.currentChapter === 1 ? '6px' : '18px')};

  &:first-child {
    width : ${props => props.activeStep === 1 ? '12px' : '26px'};
  }
`

export const ChapterInfoWrapper = styled.div`
  position: absolute;
  bottom: ${(props) => (props.nextActive ? '-48px' : '-28px')};
  right: -18px;
  width: max-content;
`

export const NextChapterText = styled.p`
  font-family: Noto Sans;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  color: #2b5570;
`

export const ProgressStepWrapper = styled.p`
  font-family: Noto Sans;
  color: #1c3d53;
  ${(props) => getProgressStyle(props.nextActive)}
`

export const GirlBackBox = styled.div`
  background-image: url('/images/girl-writer.svg');
  width: 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  height: 217px;
  align-items: center;
  justify-content: center;
  @media (max-width: 600px) {
    background-image: none;
    height: unset;
    margin-bottom: 16px;
  }
`
export const MobileGirlBackBox = styled.div`
  display: flex;
  align-items: center;
`
export const MobileGirlBackBoxTxt = styled.span`
  font-size: 18px;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
`
